import styled from 'styled-components'

import { Header, Layout, PageContent } from '@loadsmart/miranda-react'

import { type Carrier } from 'auth/domain/Carrier'

import { mockTenderList } from './mocks/mockTenderList'
import { TenderCard } from './TenderCard'
import { type TenderOffer } from './types'

export type TenderListPageProps = {
  tenders?: Array<TenderOffer>
  disabled?: boolean
  carrier?: Carrier
}

const BodyContentWrapper = styled.div`
  max-width: 1024px;
  margin-left: auto;
  margin-right: auto;
`

function TenderListPage({
  tenders = mockTenderList,
  disabled = false,
  carrier,
}: TenderListPageProps) {
  const mockCarrier: Partial<Carrier> = carrier || {
    name: 'Robin Moody 0',
    entityType: 'carrier',
    dot: '1234567890',
    mc: '1234567890',
  }

  return (
    <PageContent>
      <Header>
        <Header.Content>
          <Header.Title>Tender Offers</Header.Title>
        </Header.Content>
      </Header>
      <PageContent.Body>
        <BodyContentWrapper>
          <Layout.Stack gap="spacing-4">
            {tenders.map(tenderItem => (
              <TenderCard
                key={tenderItem.id}
                tender={tenderItem}
                disabled={disabled}
                carrier={mockCarrier}
              />
            ))}
          </Layout.Stack>
        </BodyContentWrapper>
      </PageContent.Body>
    </PageContent>
  )
}

export default TenderListPage
